import React from 'react'
import { ColSettings } from './ColSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'

export const Col = withBlock(
  props => {
    const { children } = props

    return (
      <div
        className={`block-col ${props.className}`}
        ref={ref => props.retRef(ref)}
      >
        {children?.props?.children}
      </div>
    )
  },
  {},
)

Col.craft = withCraft({
  name: 'Col',
  defaultProps: {},
  settings: ColSettings,
})
